import dateFns from 'date-fns/locale/sr';

export default {
  dateFns,

  format: {
    date: 'd.M.yyyy.',
    time: 'p',
    dateTime: '$t(format:date) $t(format:time)',
    longDate: 'd. MMM',
    longDateTime: "d. MMMM 'u' p",
    fullDate: 'd. MMM y',
    fullDateTime: "d. MMMM y 'u' p",
  },

  translation: {
    common: {
      aboutPlanka: 'O Planka',
      account: 'Налог',
      actions: 'Радње',
      addAttachment_title: 'Додај прилог',
      addComment: 'Додај коментар',
      addManager_title: 'Додај руководиоца',
      addMember_title: 'Додај члана',
      addUser_title: 'Додај корисника',
      administrator: 'Администратор',
      all: 'Све',
      allChangesWillBeAutomaticallySavedAfterConnectionRestored:
        'Све промене ће аутоматски бити сачуване<br />након успостављања конекције.',
      areYouSureYouWantToDeleteThisAttachment: 'Да ли заиста желите да обришете овај прилог?',
      areYouSureYouWantToDeleteThisBoard: 'Да ли заиста желите да обришете ову таблу?',
      areYouSureYouWantToDeleteThisCard: 'Да ли заиста желите да обришете ову картицу?',
      areYouSureYouWantToDeleteThisComment: 'Да ли заиста желите да обришете овај коментар?',
      areYouSureYouWantToDeleteThisLabel: 'Да ли заиста желите да обришете ову ознаку?',
      areYouSureYouWantToDeleteThisList: 'Да ли заиста желите да обришете овај списак?',
      areYouSureYouWantToDeleteThisProject: 'Да ли заиста желите да обришете овај пројекат?',
      areYouSureYouWantToDeleteThisTask: 'Да ли заиста желите да обришете овај задатак?',
      areYouSureYouWantToDeleteThisUser: 'Да ли заиста желите да обришете овог корисника?',
      areYouSureYouWantToLeaveBoard: 'Да ли заиста желите да напустите ову таблу?',
      areYouSureYouWantToLeaveProject: 'Да ли заиста желите да напустите овај пројекат?',
      areYouSureYouWantToRemoveThisManagerFromProject:
        'Да ли заиста желите да уклоните овог руководиоца из овог пројекта?',
      areYouSureYouWantToRemoveThisMemberFromBoard:
        'Да ли заиста желите да уклоните овог члана из ове табле?',
      attachment: 'Прилог',
      attachments: 'Прилози',
      authentication: 'Аутентификација',
      background: 'Позадина',
      board: 'Табла',
      boardNotFound_title: 'Табла није пронађена',
      canComment: 'Може да коментарише',
      canEditContentOfBoard: 'Може да уређује садржај табле.',
      canOnlyViewBoard: 'Може само да прегледа таблу.',
      cardActions_title: 'Радње над картицом',
      cardNotFound_title: 'Картица није пронађена',
      cardOrActionAreDeleted: 'Картица или радња су обрисане.',
      color: 'Боја',
      copy_inline: 'копија',
      createBoard_title: 'Направи таблу',
      createLabel_title: 'Направи ознаку',
      createNewOneOrSelectExistingOne: 'Направи нову или изабери<br />постојећу.',
      createProject_title: 'Направи пројекат',
      createTextFile_title: 'Направи текстуалну датотеку',
      currentPassword: 'Тренутна лозинка',
      dangerZone_title: 'Опасна зона',
      date: 'Датум',
      dueDate: 'Рок',
      dueDate_title: 'Рок',
      deleteAttachment_title: 'Обриши прилог',
      deleteBoard_title: 'Обриши таблу',
      deleteCard_title: 'Обриши картицу',
      deleteComment_title: 'Обриши коментар',
      deleteLabel_title: 'Обриши ознаку',
      deleteList_title: 'Обриши списак',
      deleteProject_title: 'Обриши пројекат',
      deleteTask_title: 'Обриши задатак',
      deleteUser_title: 'Обриши корисника',
      description: 'Опис',
      detectAutomatically: 'Детектуј аутоматски',
      dropFileToUpload: 'Превуци датотеку за слање',
      editor: 'Уређивач',
      editAttachment_title: 'Уреди прилог',
      editAvatar_title: 'Уреди аватара',
      editBoard_title: 'Уреди таблу',
      editDueDate_title: 'Уреди рок',
      editEmail_title: 'Уреди е-пошту',
      editInformation_title: 'Уреди информације',
      editLabel_title: 'Уреди ознаку',
      editPassword_title: 'Измени лозинку',
      editPermissions_title: 'Уреди овлашћења',
      editStopwatch_title: 'Уреди штоперицу',
      editUsername_title: 'Измени корисничко име',
      email: 'Е-пошта',
      emailAlreadyInUse: 'Е-пошта је већ у употреби',
      enterCardTitle: 'Унеси наслов картице... [Ctrl+Enter] да се аутоматски отвори.',
      enterDescription: 'Унеси опис...',
      enterFilename: 'Унеси назив датотеке',
      enterListTitle: 'Унеси наслов списка...',
      enterProjectTitle: 'Унеси наслов пројекта',
      enterTaskDescription: 'Унеси опис задатка...',
      filterByLabels_title: 'Филтрирај према ознакама',
      filterByMembers_title: 'Филтрирај према члановима',
      fromComputer_title: 'Са рачунара',
      fromTrello: 'Са Trello-а',
      general: 'Опште',
      hours: 'Сати',
      importBoard_title: 'Увези таблу',
      invalidCurrentPassword: 'Неисправна тренутна лозинка',
      labels: 'Ознаке',
      language: 'Језик',
      leaveBoard_title: 'Напусти таблу',
      leaveProject_title: 'Напусти пројекат',
      linkIsCopied: 'Веза је ископирана',
      list: 'Списак',
      listActions_title: 'Радње над списком',
      managers: 'Руководиоци',
      managerActions_title: 'Радње над руководиоцима',
      members: 'Чланови',
      memberActions_title: 'Радње над члановима',
      minutes: 'Минути',
      moveCard_title: 'Премести картицу',
      name: 'Име',
      newestFirst: 'Прво најновије',
      newEmail: 'Нова е-пошта',
      newPassword: 'Нова лозинка',
      newUsername: 'Ново корисничко име',
      noConnectionToServer: 'Нема конекције са сервером',
      noBoards: 'Нема табли',
      noLists: 'Нема спискова',
      noProjects: 'Нема пројеката',
      notifications: 'Обавештења',
      noUnreadNotifications: 'Нема непрочитаних обавештења.',
      oldestFirst: 'Прво најстарије',
      openBoard_title: 'Отвори таблу',
      optional_inline: 'опционо',
      organization: 'Организација',
      phone: 'Телефон',
      preferences: 'Својства',
      pressPasteShortcutToAddAttachmentFromClipboard:
        'Савет: притисни Ctrl-V (Cmd-V на Меку) да би додао прилог са бележнице.',
      project: 'Пројекат',
      projectNotFound_title: 'Пројекат није пронађен',
      removeManager_title: 'Уклони руководиоца',
      removeMember_title: 'Уклони члана',
      searchLabels: 'Претражи ознаке...',
      searchMembers: 'Претражи чланове...',
      searchUsers: 'Претражи кориснике...',
      searchCards: 'Претражи картице...',
      seconds: 'Секунде',
      selectBoard: 'Изабери таблу',
      selectList: 'Изабери списак',
      selectPermissions_title: 'Изабери одобрења',
      selectProject: 'Изабери пројекат',
      settings: 'Подешавања',
      sortList_title: 'Сложи списак',
      stopwatch: 'Штоперица',
      subscribeToMyOwnCardsByDefault: 'Подразумевано се претплати на сопствене картице',
      taskActions_title: 'Радње над задатком',
      tasks: 'Задаци',
      thereIsNoPreviewAvailableForThisAttachment: 'Нема прегледа доступног за овај прилог.',
      time: 'Време',
      title: 'Наслов',
      userActions_title: 'Корисничке радње',
      userAddedThisCardToList: '<0>{{user}}</0><1> је додао ову картицу на {{list}}</1>',
      userLeftNewCommentToCard: '{{user}} је оставио нови коментар «{{comment}}» у <2>{{card}}</2>',
      userMovedCardFromListToList:
        '{{user}} је преместио <2>{{card}}</2> са {{fromList}} у {{toList}}',
      userMovedThisCardFromListToList:
        '<0>{{user}}</0><1> је преместио ову картицу са {{fromList}} на {{toList}}</1>',
      username: 'Корисничко име',
      usernameAlreadyInUse: 'Корисничко име је већ у употреби',
      users: 'Корисници',
      version: 'Верзија',
      viewer: 'Прегледач',
      writeComment: 'Напиши коментар...',
    },

    action: {
      addAnotherCard: 'Додај још једну картицу',
      addAnotherList: 'Додај још један списак',
      addAnotherTask: 'Додај још један задатак',
      addCard: 'Додај картицу',
      addCard_title: 'Додај картицу',
      addComment: 'Додај коментар',
      addList: 'Додај списак',
      addMember: 'Додај члана',
      addMoreDetailedDescription: 'Додај детаљнији опис',
      addTask: 'Додај задатак',
      addToCard: 'Додај на картицу',
      addUser: 'Додај корисника',
      copyLink_title: 'Копирај везу',
      createBoard: 'Направи таблу',
      createFile: 'Направи датотеку',
      createLabel: 'Направи ознаку',
      createNewLabel: 'Направи нову ознаку',
      createProject: 'Направи пројекат',
      delete: 'Обриши',
      deleteAttachment: 'Обриши прилог',
      deleteAvatar: 'Обриши аватара',
      deleteBoard: 'Обриши таблу',
      deleteCard: 'Обриши картицу',
      deleteCard_title: 'Обриши картицу',
      deleteComment: 'Обриши коментар',
      deleteImage: 'Обриши слику',
      deleteLabel: 'Обриши ознаку',
      deleteList: 'Обриши списак',
      deleteList_title: 'Обриши списак',
      deleteNotifications: 'Dismiss all',
      deleteProject: 'Обриши пројекат',
      deleteProject_title: 'Обриши пројекат',
      deleteTask: 'Обриши задатак',
      deleteTask_title: 'Обриши задатак',
      deleteUser: 'Обриши корисника',
      duplicate: 'Клонирај',
      duplicateCard_title: 'Клонирај картицу',
      edit: 'Измени',
      editDueDate_title: 'Измени рок',
      editDescription_title: 'Измени опис',
      editEmail_title: 'Измени е-пошту',
      editInformation_title: 'Измени информације',
      editPassword_title: 'Измени лозинку',
      editPermissions: 'Измени одобрења',
      editStopwatch_title: 'Измени штоперицу',
      editTitle_title: 'Измени наслов',
      editUsername_title: 'Измени корисничко име',
      hideDetails: 'Сакриј детаље',
      import: 'Увези',
      leaveBoard: 'Напусти таблу',
      leaveProject: 'Напусти пројекат',
      logOut_title: 'Одјава',
      makeCover_title: 'Направи омот',
      move: 'Премести',
      moveCard_title: 'Премести картицу',
      remove: 'Уклони',
      removeBackground: 'Уклони позадину',
      removeCover_title: 'Уклони омот',
      removeFromBoard: 'Уклони са табле',
      removeFromProject: 'Уклони из пројекта',
      removeManager: 'Уклони руководиоца',
      removeMember: 'Уклони члана',
      save: 'Сачувај',
      showAllAttachments: 'Прикажи све ({{hidden}} сакривене прилоге)',
      showDetails: 'Прикажи детаље',
      showFewerAttachments: 'Прикажи мање прилога',
      sortList_title: 'Сложи списак',
      start: 'Почни',
      stop: 'Заустави',
      subscribe: 'Претплати се',
      unsubscribe: 'Укини претплату',
      uploadNewAvatar: 'Постави нови аватар',
      uploadNewImage: 'Постави нову слику',
    },
  },
};
